export const PROTOCOL_VERSION = 1

/** Everything a member can append to a room. */
export const OP = {
  MESSAGE: 0,
  EDIT: 1,
  DELETE: 2,
  REACTION: 3,
  MEMBER_ADD: 4,
  MEMBER_REMOVE: 5,
  MEMBER_ROLE: 6,
  ROOM_META: 7,
  READ: 8,
  PIN: 9,
  POLL_VOTE: 10,
  CALL_LOG: 11,
  WRITER_ADD: 12,
  WRITER_REMOVE: 13
}

export const OP_NAME = Object.fromEntries(Object.entries(OP).map(([k, v]) => [v, k]))

/** Message content kinds. */
export const KIND = {
  TEXT: 0,
  IMAGE: 1,
  VIDEO: 2,
  AUDIO: 3,      // voice note
  FILE: 4,
  STICKER: 5,
  GIF: 6,
  LOCATION: 7,
  CONTACT: 8,
  POLL: 9,
  SYSTEM: 10
}

export const KIND_NAME = Object.fromEntries(Object.entries(KIND).map(([k, v]) => [v, k.toLowerCase()]))

/** Inline text formatting, offsets are in UTF-16 code units to match the DOM. */
export const ENTITY = {
  BOLD: 0,
  ITALIC: 1,
  UNDERLINE: 2,
  STRIKE: 3,
  CODE: 4,
  PRE: 5,
  LINK: 6,
  MENTION: 7,
  SPOILER: 8,
  QUOTE: 9
}

export const ENTITY_NAME = Object.fromEntries(Object.entries(ENTITY).map(([k, v]) => [v, k.toLowerCase()]))

/** Room shapes. Determines defaults, not permissions — see permissions.js. */
export const ROOM_TYPE = {
  DM: 0,        // exactly two members, no admin concept
  GROUP: 1,     // everyone writes, admins moderate
  CHANNEL: 2,   // broadcast: only admins write, members read and react
  SAVED: 3      // single-member notes-to-self
}

export const ROOM_TYPE_NAME = Object.fromEntries(Object.entries(ROOM_TYPE).map(([k, v]) => [v, k.toLowerCase()]))

export const ROLE = {
  OWNER: 4,
  ADMIN: 3,
  MODERATOR: 2,
  MEMBER: 1,
  RESTRICTED: 0
}

export const ROLE_NAME = Object.fromEntries(Object.entries(ROLE).map(([k, v]) => [v, k.toLowerCase()]))

/** Deletion scope. */
export const DELETE_SCOPE = { ME: 0, EVERYONE: 1 }

export const CALL_STATE = {
  RINGING: 0,
  ACTIVE: 1,
  ENDED: 2,
  MISSED: 3,
  DECLINED: 4
}

/** Ephemeral protomux channels — never persisted to a core. */
export const EPHEMERAL = {
  TYPING: 'typing',
  PRESENCE: 'presence',
  CALL_SIGNAL: 'call',
  RECEIPT: 'receipt'
}

export const LIMITS = {
  MESSAGE_TEXT: 8192,
  ROOM_NAME: 128,
  ROOM_DESCRIPTION: 1024,
  DISPLAY_NAME: 64,
  BIO: 280,
  ATTACHMENTS_PER_MESSAGE: 10,
  ENTITIES_PER_MESSAGE: 128,
  POLL_OPTIONS: 12,
  REACTION_LENGTH: 16,
  MAX_BLOB_BYTES: 2 * 1024 * 1024 * 1024,
  MAX_INLINE_THUMB: 24 * 1024
}
